export const buildFilters = (initialFilters: any, productGeo: string) => {
  const { productCategories = [], ...filters } = { ...(initialFilters ?? {}), geos: productGeo };

  if (productCategories.length) {
    return {
      ...filters,
      categories: productCategories.map((x: any) => x.categories),
    };
  }
  return filters;
};

export const SCHEMA_FILTERS = {
  'https://traegergrills.com/data/contentTypes/productCategoryFilterOptions.json': 'categories',
  'https://traegergrills.com/data/contentTypes/grillSeriesFilterOptions.json': 'grillSeries',
  'https://traegergrills.com/data/contentTypes/grillFeatureFilterOptions.json': 'features',
  'https://traegergrills.com/data/contentTypes/grillCompatibilityFilterOptions.json':
    'grillCompatibility',
  'https://traegergrills.com/data/contentTypes/productFitFilterOptions.json': 'apparelFit',
  'https://traegergrills.com/data/contentTypes/productSizeFilterOptions.json': 'apparelSize',
  'https://traegergrills.com/data/contentTypes/pairsWithFilterOptions.json': 'pairings',
};
